import { render, staticRenderFns } from "./UpdateItemPriceModal.vue?vue&type=template&id=763a8555&"
import script from "./UpdateItemPriceModal.vue?vue&type=script&lang=js&"
export * from "./UpdateItemPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports